// extracted by mini-css-extract-plugin
export default {"headerBar":"eQ-z","pointsSection":"fQ-z","goToDashboard":"gQ-z"};